import { createI18n } from 'vue-i18n'

import enDefault from '@/i18n/en/default.js'
import enErrors from '@/i18n/en/errors.js'
import enGDPR from '@/i18n/en/gdpr.js'
import frDefault from '@/i18n/fr/default.js'
import frErrors from '@/i18n/fr/errors.js'
import frGDPR from '@/i18n/fr/gdpr.js'

export default createI18n({
  legacy: false,
  locale: 'fr',
  fallbackLocale: 'fr',
  messages: {
    en: {
      ...enDefault,
      errors: enErrors,
      gdpr: enGDPR,
    },
    fr: {
      ...frDefault,
      errors: frErrors,
      gdpr: frGDPR,
    },
  },
})
